const styles = theme => ({
  boxSpace: {
    // marginTop: 55,
    margin: theme.spacing(4)
  },
  buttonStyle: {
    backgroundColor: theme.palette.secondary.light,
    width: 160,
    height: 36,
    margin: "auto",
    fontSize: 14,
    fontWeight: 400,
    color: theme.palette.warning.light,
    textAlign: "center",
    fontFamily: "Roboto",
    borderRadius: 2,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light
    },
    [theme.breakpoints.down("md")]: {
      display: "none"
    }
  },

  sortIcon: {
    color: theme.palette.primary.light
  },
  nameDiv: {
    color: theme.palette.primary.light,
    textAlign: "left",
    fontFamily: "Roboto",
    letterSpacing: 0,
    textTransform: "uppercase",
    fontSize: 16,
    fontWeight: 400,
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      display: "none"
    }
  },
  searchBar: {
    backgroundColor: theme.palette.secondary.light,
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  searchIcon: {
    color: "black",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    top: 5,
    position: "relative"
  },
  searchInput: {
    color: theme.palette.primary.dark,
    opacity: 0.38,
    fontFamily: "Roboto",
    fontSize: 14,
    letterSpacing: 0
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Settings/styles.js